export const resultsKeys = [
  "PV_production",
  "PV_electrochemical_storage_model",
  "PV_hourly_energy_balances_monthly",
  "PV_environmental_impact",
  "PV_npv_full_calculus_dict",
  "PV_irr",
  "PV_irr_squared",
  "PV_LCOE_full_calculus_dict",
  "PV_LCOE",
  "WT_production",
  "WT_electrochemical_storage_model",
  "WT_hourly_energy_balances_monthly",
  "WT_environmental_impact",
  "WT_npv_full_calculus_dict",
  "WT_irr",
  "WT_irr_squared",
  "WT_LCOE_full_calculus_dict",
  "WT_LCOE",
  "PVWT_production",
  "PVWT_electrochemical_storage_model",
  "PVWT_hourly_energy_balances_monthly",
  "PVWT_npv_full_calculus_dict",
  "PVWT_irr",
  "PVWT_irr_squared",
  "PVWT_LCOE_full_calculus_dict",
  "PVWT_LCOE",
];
